// extracted by mini-css-extract-plugin
export default {"card":"LoadingSkeleton_card__NQYtn","shimmer":"LoadingSkeleton_shimmer__u7+aO"};